// extracted by mini-css-extract-plugin
export var createdDate = "_ko-1";
export var divider = "_ko-2";
export var headerDivider = "_ko-3";
export var messagesCard = "_ko-0";
export var messagesContainer = "_ko-7";
export var messagesContainerWrapper = "_ko-4";
export var pointerCapturingButtonBoxes = "_ko-a";
export var showLeftPanelButton = "_ko-9";
export var showMoreButton = "_ko-c";
export var showMoreButtonContainer = "_ko-b";
export var summaryTitle = "_ko-6";
export var systemMessageCardWrapper = "_ko-d";
export var topButtons = "_ko-8";
export var withPadding = "_ko-5";